import {
  COLLECTIONS_RESPONCE_FOR_REST_API_BEGIN,
  COLLECTIONS_RESPONCE_FOR_REST_API_SUCCESS,
  COLLECTIONS_RESPONCE_FOR_REST_API_FAILURE,
  COLLECTIONS_RESPONCE_FOR_REST_API_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';

export function responceForRestApi(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_RESPONCE_FOR_REST_API_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const { methodType, url, headers, body, fullData } = args;
      let doRequest;
      if (methodType === 'get') {
        doRequest = axios.get(url, { headers });
      } else {
        doRequest = axios.post(url, body, { headers });
      }
      doRequest.then(
        (res) => {
          console.log('args', args);
          let responseData;
          if (!args.fullData) {
            responseData = res.data.length >= 2 ? res.data[0] : res.data;
          } else {
            responseData = res.data;
          }
          dispatch({
            type: COLLECTIONS_RESPONCE_FOR_REST_API_SUCCESS,
            data: responseData,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_RESPONCE_FOR_REST_API_FAILURE,
            data: { error: err },
          });
          toast.error('This is not a valid URL');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissResponceForRestApiError() {
  return {
    type: COLLECTIONS_RESPONCE_FOR_REST_API_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_RESPONCE_FOR_REST_API_BEGIN:
      return {
        ...state,
        responceForRestApiPending: true,
        responceForRestApiError: null,
      };

    case COLLECTIONS_RESPONCE_FOR_REST_API_SUCCESS:
      return {
        ...state,
        responseData: action.data,
        responceForRestApiPending: false,
        responceForRestApiError: null,
      };

    case COLLECTIONS_RESPONCE_FOR_REST_API_FAILURE:
      return {
        ...state,
        responceForRestApiPending: false,
        responceForRestApiError: action.data.error,
      };

    case COLLECTIONS_RESPONCE_FOR_REST_API_DISMISS_ERROR:
      return {
        ...state,
        responceForRestApiError: null,
      };

    default:
      return state;
  }
}
